import { functions } from '@/firebase';
import { httpsCallable } from 'firebase/functions';
import {
  BuyTicketRequest,
  GetPaymentUrlRequest,
  GetPaymentUrlResponse,
  Ticket,
} from '@packages/types';

export const buyTicketFn = httpsCallable<BuyTicketRequest, { ticket: Ticket }>(
  functions,
  'buyTicket',
);

export const getPaymentUrlFn = httpsCallable<GetPaymentUrlRequest, GetPaymentUrlResponse>(
  functions,
  'getPaymentUrl',
);
